import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import type { CdkOverlayContainer } from '@shared/services/cdk-overlay-container.service';

@Directive({
  selector: '[appMyCdkOverlayContainer]',
})
export class CdkOverlayContainerDirective {
  protected renderer = inject(Renderer2);
  protected elementReference = inject(ElementRef);
  protected cdkOverlayContainer = inject(
    OverlayContainer,
  ) as CdkOverlayContainer;

  constructor() {
    this.renderer.addClass(
      this.elementReference.nativeElement,
      'cdk-overlay-container',
    );

    this.cdkOverlayContainer.setContainerElement(
      this.elementReference.nativeElement,
    );
  }
}
